<template>
  <!--
      	作者：luoyiming
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表-编辑活动-其它
      -->
  <div>
    <div class="common-form">高级设置</div>

    <div v-if="Number(form.coupon_type) === 10 || Number(form.coupon_type) === 50 ">
      <el-form-item label="减免金额">
        <el-input v-model="form.reduce_price" placeholder="请输入减免金额" type="number"></el-input>
      </el-form-item>
    </div>
    <div v-else>
      <el-form-item label="折扣率 ">
        <el-input v-model="form.discount" placeholder="请输入折扣率" type="number"></el-input>
        <div class="tips">折扣率范围0-100，95代表95折，0代表不折扣</div>
      </el-form-item>
    </div>

        <el-form-item label="限制每人领取次数">
      <el-input v-model="form.min_recive" placeholder="请输入限制每人领取次数" type="number"></el-input>
        <div class="tips">-1不限制领取次数</div>
    </el-form-item>

    <el-form-item label="最低消费金额">
      <el-input v-model="form.min_price" placeholder="请输入最低消费金额" type="number"></el-input>
    </el-form-item>

    <el-form-item label="发放总数量 " prop="total_num" :rules="[{ required: true, message: ' ' }]">
      <el-input v-model="form.total_num" placeholder="请输入发放总数量" type="number"></el-input>
      <div class="tips">限制领取的优惠券数量，-1为不限制</div>
    </el-form-item>
    <el-form-item label="排序">
      <el-input type="number" v-model="form.sort" placeholder="请输入排序"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: ['form'],
  data() {
    return {}
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/part/Coupon.vue